const getters = {
    subscriptionStatus: state => state.subscriptionStatus,
    subscriptionErrors: state => state.subscriptionErrors,
    subscriptions: state => state.subscriptions,

    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,
}

export default getters